import React from 'react';
import { situations } from '../data/site';
export function HowIHelp() {
  return <section id="how-i-help" className="border-b border-rule" data-id="element-65" data-mp="ygnmpsaqls10">
      <div className="max-w-content mx-auto px-6 lg:px-10 py-20 md:py-24" data-id="element-66" data-mp="yg5fk0mjdteb">
        <div className="max-w-2xl" data-id="element-67" data-mp="1dcd3nc12feyv">
          <h2 className="font-serif text-3xl md:text-4xl leading-tight tracking-tight text-ink" data-id="element-68" data-mp="1dbbr134eikf1">
            When to bring me in
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-ink-soft" data-id="element-69" data-mp="ko7d28nbyvr4">
            Sometimes the organization knows exactly what is wrong. Sometimes it only knows that
            something important is not working. I help diagnose the problem, align the team, and
            lead the work through implementation.
          </p>
        </div>

        <ul className="mt-12 grid md:grid-cols-2 gap-px bg-rule border border-rule rounded-lg overflow-hidden" data-id="element-70" data-mp="pm0kt64a7xti">
          {situations.map(situation => <li key={situation.title} className="bg-paper p-7 md:p-9 flex flex-col hover:bg-paper-soft transition-colors duration-200" data-id="element-71" data-mp="3t5loie7w1s6k">
              <h3 className="font-serif text-xl md:text-[1.375rem] leading-snug text-ink" data-id="element-72" data-mp="2azx1qsma0oza">
                {situation.title}
              </h3>
              <p className="mt-4 text-base leading-relaxed text-ink-soft" data-id="element-73" data-mp="2frf7dtz8vdql">{situation.body}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}